/**
 * Map provider configuration.
 *
 * Swap providers by changing this file (or the env var) — the components render
 * the base map via `<MapLibreTiles>`, which reads only the constants below.
 *
 * Base map: **OpenFreeMap** vector tiles (https://openfreemap.org) — free for
 * commercial use, no API key, no usage limits, same in dev and prod. This
 * replaces the public OSM raster tile server (`tile.openstreetmap.org`), which
 * bars heavy/commercial use. Override with `VITE_MAP_STYLE_URL` to point at any
 * other MapLibre style (a self-hosted Protomaps/OpenFreeMap build, etc.).
 *
 * Attribution is mandatory under OSM's ODbL licence; we render it on the map.
 */

// MapLibre GL style JSON (vector). OpenFreeMap's "liberty" style by default.
export const MAP_STYLE_URL =
  import.meta.env.VITE_MAP_STYLE_URL || 'https://tiles.openfreemap.org/styles/liberty';

export const MAP_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const MAP_TILE_OPTIONS = {
  // Vector tiles scale cleanly; cap zoom to keep parity with the old raster setup.
  maxZoom: 19,
};

export const DEFAULT_MAP_ZOOM = 12;

export const MIN_RADIUS_KM = 1;
export const MAX_RADIUS_KM = 500;
export const DEFAULT_RADIUS_KM = 10;
